import type { CSSProperties } from "react";

/** Glass form-card surface (matches Contact.tsx / JobPostings.tsx). */
export const glassCardStyle: CSSProperties = {
  background: "var(--landing-glass-bg)",
  border: "1px solid var(--landing-glass-border)",
  boxShadow: "var(--landing-card-shadow)",
};

/** Input / select / textarea surface. */
export const inputStyle: CSSProperties = {
  background: "var(--landing-surface)",
  border: "1px solid var(--landing-glass-border)",
  color: "var(--landing-text)",
  boxShadow: "0 1px 2px rgba(0,0,0,0.02) inset",
};

/** Secondary button / tile surface. */
export const surfaceStyle: CSSProperties = {
  background: "var(--landing-surface)",
  border: "1px solid var(--landing-glass-border)",
  color: "var(--landing-text)",
};

/** Shared input className with the electric focus ring. */
export const inputClass =
  "h-12 rounded-lg text-sm transition-shadow focus-visible:ring-1 focus-visible:ring-[var(--acc2)]";

export const ELECTRIC = "var(--acc2)";
